import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { shelfItemShape, userIdentityShape, ugcIOwnThisShape } from '@bibliocommons/bc-prop-types';
import AddToShelfComboButtonContainer from 'app/components/deprecated/shared/AddToShelfComboButton/AddToShelfComboButtonContainer';
import ItemTransactionButtonContainer from 'app/components/shared/ItemTransactionButton/ItemTransactionButtonContainer';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';
import ShelfListItemOptionsDropdown from '../OptionsDropdown';

import './SecondaryInfo.scss';

function renderOptionsDropdown(
  item,
  currentUserShelfItemForBib,
  shelfTransactions,
  owner,
  shelfActions,
  ownerSettingForBib,
  iOwnThisActions,
  iOwnThisTransactions,
  modalActions,
  trackContentCollectionMove
) {
  if (currentUserShelfItemForBib) {
    return (
      <ShelfListItemOptionsDropdown
        currentUserShelfItem={currentUserShelfItemForBib}
        shelfTransactions={shelfTransactions}
        updateShelfItem={shelfActions.updateShelfItems}
        removeShelfItem={shelfActions.removeShelfItems}
        searchUserShelf={shelfActions.searchUserShelf}
        ownerSettingForBib={ownerSettingForBib}
        iOwnThisActions={iOwnThisActions}
        iOwnThisTransactions={iOwnThisTransactions}
        owner={owner}
        modalActions={modalActions}
        shelfActions={shelfActions}
        trackContentCollectionMove={trackContentCollectionMove}
      />
    );
  }

  return <AddToShelfComboButtonContainer metadataId={item.get('metadataId')} />;
}

export default function ShelfListItemSecondaryInfo({
  item,
  currentUserShelfItemForBib,
  shelfTransactions,
  owner,
  shelfActions,
  ownerSettingForBib,
  iOwnThisActions,
  iOwnThisTransactions,
  modalActions,
  trackContentCollectionMove
}) {
  const formattedDate = <ShortFormattedDate value={item.get('dateAdded')} />;

  return (
    <div className="cp-shelf-list-item-secondary-info">
      <div className="shelf-add-to-shelf">
        {renderOptionsDropdown(
          item,
          currentUserShelfItemForBib,
          shelfTransactions,
          owner,
          shelfActions,
          ownerSettingForBib,
          iOwnThisActions,
          iOwnThisTransactions,
          modalActions,
          trackContentCollectionMove
        )}
      </div>

      <div className="shelf-item-transaction-buttons">
        <ItemTransactionButtonContainer id={item.get('metadataId')} />
      </div>

      <div className="shelf-date-info">
        <FormattedMessage id="ada_shelf_added_on" values={{ date: formattedDate }} />
      </div>
    </div>
  );
}

ShelfListItemSecondaryInfo.propTypes = {
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisTransactions: ImmutablePropTypes.map.isRequired,
  ownerSettingForBib: ugcIOwnThisShape,
  currentUserShelfItemForBib: shelfItemShape,
  modalActions: PropTypes.objectOf(PropTypes.func),
  trackContentCollectionMove: PropTypes.func
};
